import React, { useEffect, useState } from 'react';

// COMPONENTS
import Icon from '../Icon/Icon';

// ENUMS
import { Icons } from '../../enums/icons';

// INTERFACES
import { ICollapse } from '../../interfaces/Collapse.interface';

// STYLES
import {
  Accordion,
  AccordionAction,
  AccordionContent,
  AccordionContentText,
  AccordionHead,
  AccordionItem,
  AccordionSubTitle,
  AccordionTitle,
  BadgeContainer,
  CollapseContainer,
  Counter,
  IconContainer,
  OptionsContainer
} from './styles';

const Collapse: React.FC<ICollapse> = ({
  badge: BadgeProp,
  children,
  collapsed,
  counter,
  icon: IconProp,
  inside,
  insideTwo,
  isCapitalizeText,
  keepBadge = false,
  noBorder,
  paddingAccordion,
  marginAccordion,
  paddingItem,
  marginItem,
  options,
  smallWidth,
  subtitle,
  title
}: ICollapse) => {
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    setOpen(collapsed);
  }, [collapsed]);

  return (
    <CollapseContainer>
      <Accordion
        inside={inside}
        isOpen={isOpen}
        noBorder={noBorder}
        paddingAccordion={paddingAccordion}
        marginAccordion={marginAccordion}
        smallWidth={smallWidth}
      >
        <AccordionContent isCapitalizeText={isCapitalizeText}>
          {IconProp && (
            <IconContainer onClick={() => setOpen(!isOpen)}>
              <IconProp />
            </IconContainer>
          )}
          <AccordionContentText>
            <AccordionHead onClick={() => setOpen(!isOpen)}>
              <AccordionTitle>
                {title}
                {(counter || 0) > 1 && <Counter> ({counter}) </Counter>}
              </AccordionTitle>
              <AccordionSubTitle>{subtitle}</AccordionSubTitle>
            </AccordionHead>
            {BadgeProp && (!isOpen || keepBadge) && (
              <BadgeContainer>
                <BadgeProp />
              </BadgeContainer>
            )}
          </AccordionContentText>
          {options && <OptionsContainer>{options}</OptionsContainer>}
          <AccordionAction onClick={() => setOpen(!isOpen)}>
            <Icon type={isOpen ? Icons.ARROW_UP : Icons.ARROW_DOWN} />
          </AccordionAction>
        </AccordionContent>
        <AccordionItem
          inside={inside}
          insideTwo={insideTwo}
          isOpen={isOpen}
          marginItem={marginItem}
          paddingItem={paddingItem}
        >
          {children}
        </AccordionItem>
      </Accordion>
    </CollapseContainer>
  );
};

export default Collapse;
